import React from "react";
import { Route } from "react-router-dom";

import { APP_MINI_NAME } from "../constants/app-constants";
import useDocumentTitle from "../Hooks/useDocumentTitle";

const CustomRoute = (props) => {
    useDocumentTitle(`${APP_MINI_NAME} | ${props.title}`);
    return <Route {...props} />;
};

export default CustomRoute;